<template>
<div class="container">

    <rc-widget-live-results-body
      page_basename="house_top_50" 
      page_name="House"
      page_sub="Top Races"
    ></rc-widget-live-results-body>

</div>
</template>

<script>

import ElectionNightMixin from './ElectionNightMixin.js';

const RcWidgetLiveResultsBody = () => import(/* webpackChunkName: "RcWidgetLiveResultsBody" */ "./RcWidgetLiveResultsBody.vue");

export default {
    name: 'rc-widget-live-results-house-top-50',
    mixins: [
        ElectionNightMixin,
    ],
    components: {
        'rc-widget-live-results-body': RcWidgetLiveResultsBody,
    },
}
</script>

<style lang="scss">

</style>